interface Props {
  className?: string;
}

export default function EmptyStarIcon({className}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      className={className}>
      <path
        fillRule="nonzero"
        d="m9 13.196 3.629 2.006-.693-4.249 2.935-3.009-4.057-.62L9 3.46 7.186 7.324l-4.057.62 2.935 3.01-.693 4.248L9 13.196Zm0 1.73L3.438 18 4.5 11.488 0 6.875l6.219-.95L9 0l2.781 5.925 6.219.95-4.5 4.613L14.562 18 9 14.925Z"
      />
    </svg>
  );
}
